module.exports = __webpack_public_path__ + "static/media/MC-Logo2.de608791.png";